import Api from "~/service/Api";

class Immersive3dTourRepository {
  fetch(query = {}) {
    return Api.get("/immersive-3d-tours", query);
  }

  create(tourId) {
    return Api.post("/immersive-3d-tours", {
      tourId,
    });
  }

  fetchOne(tourId, query) {
    return Api.get(`/immersive-3d-tours/${tourId}`, query);
  }

  fetchOrCreate(tourId) {
    return new Promise((resolve, reject) => {
      this.fetch({ tourId })
        .then(fetchResponse => {
          if (fetchResponse.data.immersive3dTours.length > 0) {
            resolve(fetchResponse.data.immersive3dTours[0]);
            return;
          }

          this.create(tourId)
            .then(createResponse => {
              resolve(createResponse.data.immersive3dTour);
            })
            .catch(reject);
        })
        .catch(reject);
    });
  }

  update(tourId, data) {
    return Api.put(`/immersive-3d-tours/${tourId}`, data);
  }

  deliver(tourId) {
    return Api.post(`/immersive-3d-tours/${tourId}/deliver`);
  }

  uploadFromPhotoEditingImage(tourId, photoEditingImageId) {
    return Api.post(`/immersive-3d-tours/${tourId}/upload-from-photo-editing-image/${photoEditingImageId}`);
  }

  delete(tourId) {
    return Api.delete(`/immersive-3d-tours/${tourId}`);
  }

  process(tourId, data = {}) {
    return Api.post(`/immersive-3d-tours/${tourId}/process`, data);
  }

  updateImageData(tourId, data = {}) {
    return Api.post(`/immersive-3d-tour/image-data/${tourId}`, data);
  }
}

export default Immersive3dTourRepository;
